import { render, staticRenderFns } from "./ServicerBranch.vue?vue&type=template&id=fc9c922a&"
import script from "./ServicerBranch.vue?vue&type=script&lang=ts&"
export * from "./ServicerBranch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports